import PerformanceDashboardContainer from "../../../Component/Application/Performance/performance-dashboard-container";

const PerformancePage = () => {
     return (
        <div className="page-body">
            <PerformanceDashboardContainer />
        </ div>
     );
};

export default PerformancePage;